module.exports = __webpack_public_path__ + "img/iPhones-3x.fba6c5ce.png";